import React, { useMemo } from 'react';
import { BarChart2 } from 'lucide-react';

import { cn } from '@epoch-ui/lib/utils';
import dayjs from 'utils/extendedDayJS';

import { useEditableEvent } from '../../../hooks/useEditableEvent';

interface EmptyFeedbackResponsesProps {
  className?: string;
}

export const EmptyFeedbackResponses: React.FC<EmptyFeedbackResponsesProps> = ({
  className = ''
}) => {
  const event = useEditableEvent();

  const emptyResponsesText = useMemo(() => {
    if (!event.isPublished) {
      return 'Publish the event to get responses';
    }
    if (event.feedbackSchedule?.sendAt) {
      if (dayjs.utc(event.feedbackSchedule.sendAt).isBefore(dayjs.utc())) {
        return 'Resend feedback form to get responses';
      }
      return 'Feedback form is scheduled to be sent';
    }
    return '';
  }, [event.isPublished, event.postQuestions, event.feedbackSchedule]);

  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-md tw-border',
        'tw-border-dashed tw-border-border-grey tw-py-5 tw-text-center',
        className
      )}
    >
      <BarChart2 className="tw-mb-1 tw-text-medium-grey" strokeWidth={3} />
      <h3 className="tw-mb-0.5 tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
        No responses yet
      </h3>
      <p className="tw-text-xs tw-leading-4 tw-text-primary-grey">{emptyResponsesText}</p>
    </div>
  );
};
